module.exports = __webpack_public_path__ + "img/intro-bg.49aa56d8.png";